import { useState } from 'react'
import { useWeb3React } from '@web3-react/core';
import { WalletLinkConnector } from "@web3-react/walletlink-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { InjectedConnector } from "@web3-react/injected-connector";

function Modal(){
    const [flag, setFlag] = useState(false)
    const {error, activate} = useWeb3React()

    const reset = (value) => {
        setFlag(value)
    }

    const CoinbaseWallet = new WalletLinkConnector({
        url: 'https://mainnet.infura.io/v3/a6184b6be8424815bdc51ea309e58217',
        appName: "ventiheadz",
        infuraId:"a6184b6be8424815bdc51ea309e58217",
        supportedChainIds: [1, 3, 4, 5, 42],
       });
    
      const WalletConnect = new WalletConnectConnector({
        rpcUrl: 'https://mainnet.infura.io/v3/a6184b6be8424815bdc51ea309e58217',
        bridge: "https://bridge.walletconnect.org",
        infuraId:"a6184b6be8424815bdc51ea309e58217",
        qrcode: true,
      });
     
      const Injected = new InjectedConnector({
        supportedChainIds: [1, 3, 4, 5, 42],
        infuraId:'a6184b6be8424815bdc51ea309e58217'
      });

      const connectWallet = async(connector) => {
        try{
          await activate(connector);      
        }catch(err){
          console.log(err)
          setFlag(true)
        }
      } 
    return(
        <div>
            <button className="block w-full mt-4 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" type="button" data-modal-toggle="small-modal">
             Connect Wallet
            </button> 
            <div id="small-modal" tabIndex="-1" className="hidden overflow-y-auto overflow-x-hidden fixed top-20 right-0 left-0 z-50 w-full md:inset-0 h-modal md:h-full">
                <div className="relative p-4 w-full max-w-md h-full md:h-auto">
                    <div className="relative text-white bg-gray-800 rounded-lg shadow dark:bg-gray-700">
                        <div className="flex justify-between items-center p-5 rounded-t border-b dark:border-gray-600">
                            <h3 className="text-xl font-medium dark:text-white">
                                Wallet Options
                            </h3>
                            <button type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-toggle="small-modal">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>  
                            </button>
                        </div>
                        <div className="p-6">
                            <p className="text-sm font-normal text-gray-500 dark:text-gray-400">Connect with one of our available wallet providers or create a new one.</p>
                            <ul className="my-4 space-y-3">
                                <li>
                                <button onClick={() => {connectWallet(Injected)}} type="button" data-modal-toggle="small-modal" className="text-white text-left w-full bg-gray-700 hover:bg-gray-600 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg font-bold px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700">Metamask</button>
                                </li>
                                <li>
                                <button onClick={() => {connectWallet(CoinbaseWallet)}}  type="button" data-modal-toggle="small-modal" className="text-white text-left w-full bg-gray-700 hover:bg-gray-600 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg font-bold px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700">Coinbase</button>
                                </li>
                                <li>
                                <button onClick={() => {connectWallet(WalletConnect)}} type="button" data-modal-toggle="small-modal" className="text-white text-left w-full bg-gray-700 hover:bg-gray-600 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg font-bold px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700">WalletConnect</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    )
}

export default Modal